import Translate from "utils/Translate";
import React, { useContext } from 'react'
import ArrowRightAlt from '../icons/ArrowRightAlt';
import { AppContext } from 'contexts/AppContext';
import {createUseStyles} from 'react-jss'
import CircularIndeterminate from "components/blocks/progressBar/progressBar";

const jss = createUseStyles({
    buttonLarge4: {
        backgroundColor: 'transparent',
        color: (styleGuide) => styleGuide.color || styleGuide.color7,
        borderRadius: (styleGuide) => styleGuide.buttonBorderRadius,
        height: (styleGuide) => styleGuide.buttonLargeHeight,
        fontSize: (styleGuide) => styleGuide.buttonLargeFontSize,
        fontFamily: (styleGuide) => styleGuide.secondaryFontFamily,
        lineHeight: (styleGuide) => styleGuide.buttonLargeLineHeight,
        fontWeight: '500',
        padding: '14px 16px',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        border: (styleGuide) => `1px solid ${styleGuide.color4}`,
        '& path': {
            fill: (styleGuide) => styleGuide.color || styleGuide.color7,
        },
        '&:hover':{
            border: (styleGuide) => `1px solid ${styleGuide.color16}`,
            color: (styleGuide) => styleGuide.color16,
            '& path': {
                fill: (styleGuide) => styleGuide.color16,
            }
        },
        '&:disabled':{
            backgroundColor: 'transparent',
            opacity: 0.7,
            cursor: 'not-allowed'
        }
    }
})


const ButtonLarge4 = (props) => {
    const { styleGuide } = useContext(AppContext)
    const classes = jss({...styleGuide, color: props.color})

    const showIcon = (typeof props.showIcon === 'boolean') ? props.showIcon : true

    return (
        <button
            title={props.title || ""}
            onClick={props.onClick}
            style={{...props.style}}
            disabled={props.disabled}
            className={classes.buttonLarge4}
        >
            {props.loading && !showIcon
                ? <CircularIndeterminate size={16} />
                : props.configuredLabel 
                    ? <span>{props.configuredLabel}</span>
                    : <Translate translationKey={props.translationKey}>{props.fallbackText || props.children}</Translate>
            }
            {showIcon 
                ?   props.icon 
                        ? props.icon
                        : <ArrowRightAlt style={{ marginLeft:'20px' }} />
                :   null
            }
        </button>
    )
}

export default ButtonLarge4;